export function getFilterDataByName(loadOptions, paramName, isDate = false) {
  if (loadOptions?.filter) {
    if (loadOptions.filter.length == 3 && loadOptions.filter[0] == paramName && loadOptions.filter.filterValue) {
      if (isDate) {
        return loadOptions.filter.filterValue.getDate();
      }
      return loadOptions.filter.filterValue;
    } else {
      let checkObject = loadOptions.filter.find((f) => f[0] == paramName);
      if (checkObject) {
        if (isDate) {
          return checkObject.filterValue.getDate();
        }
        return checkObject.filterValue;
      }
    }
  }
  return null;
}

export function getSortByProperty(loadOptions, attributeOptions) {
  if (loadOptions?.sort && loadOptions?.sort.length > 0) {
    let sortByField = loadOptions.sort[0].selector;
    if (attributeOptions) {
      sortByField = attributeOptions.find((a) => a.field == sortByField).sortField;
    }
    return sortByField;
  }
  return null;
}

export function getSortDirection(loadOptions) {
  if (loadOptions?.sort && loadOptions?.sort.length > 0) {
    return loadOptions.sort[0].desc ? "DESC" : "ASC";
  }
  return null;
}

// save grid settings, in list context nedd to set gridRefKey, dataGridInstance, -
// saveColumnSettingsTimeout, visibilitySettingsLoading, visibilitySettingsLoaded
export function saveDxGridColumnSettings(context, event) {
  if (!context || !event) {
    return;
  }

  let settings_for_save_changed = false;
  // Check if the event is related to column visibility
  // Check if the event is related to column visibleIndex
  // Check if the event is related to column width
  if (
    event.fullName.startsWith("columns[") &&
    (event.fullName.endsWith("].visible") || event.fullName.endsWith("].width") || event.fullName.endsWith("].visibleIndex")) &&
    !context.visibilitySettingsLoading
  ) {
    settings_for_save_changed = true;
  }

  if (!settings_for_save_changed || !context.gridRefKey) {
    return;
  }

  clearTimeout(context.saveColumnSettingsTimeout);
  context.saveColumnSettingsTimeout = setTimeout(() => {
    if (context?.visibilitySettingsLoading) return;

    if (context?.dataGridInstance) {
      const allColumns = context.dataGridInstance.getController("columns").getColumns();

      // Collect column settings (visibility, width, and visibleIndex)
      const columnSettings = allColumns
        .filter((column) => column.dataField) // Only include columns with a valid dataField
        .map((column) => ({
          dataField: column.dataField,
          width: column.width || column.visibleWidth, // Use `width` or fallback to `visibleWidth`
          visible: column.visible,
          visibleIndex: column.visibleIndex,
        }));

      context.setDxGridSettings({
        grid_identifier: context.gridRefKey,
        grid_column_settings: JSON.stringify(columnSettings),
      });
    }
  }, 3000);
}

export function loadDxGridColumnSettings(context) {
  if (context && !context?.visibilitySettingsLoaded && context?.gridRefKey) {
    context.visibilitySettingsLoading = true;
    setTimeout(() => {
      context
        .getDxGridSettings({
          grid_identifier: context.gridRefKey,
        })
        .then((result) => {
          if (result && result[0] && context && context?.dataGridInstance) {
            const columnSettings = result[0].grid_column_settings || [];
            // If grid_page_settings exists in the result, assign it to context
            if (result[0].grid_page_settings && context.grid_page_settings) {
              context.grid_page_settings = result[0].grid_page_settings;
            }

            context.dataGridInstance.beginUpdate();

            // Apply column settings (visibility, width, and visibleIndex)
            columnSettings.forEach(({ dataField, width, visible, visibleIndex }) => {
              context.dataGridInstance.columnOption(dataField, {
                visible: visible,
                width: width,
                visibleIndex: visibleIndex,
              });
            });

            context.dataGridInstance.endUpdate();
          }
          if (context) {
            context.visibilitySettingsLoading = false;
            context.dataGridInstance.refresh();
          }
        });
    }, 500);
    context.visibilitySettingsLoaded = true;
  }
}

export function dxFilterKeyExist(filterKey, filters) {
  let found = false;
  let i = 0;
  // Check if the filter contains 'filterKey'
  if (filters && Array.isArray(filters)) {
    while (i < filters.length) {
      if (filters[i] && (filters[i] == filterKey || (Array.isArray(filters[i]) && filters[i][0] == filterKey))) {
        found = true;
        break; // Exit the loop if we found
      } else {
        i++;
      }
    }
  }

  return found;
}

export function getDxFilterValueByKey(filterKey, filters) {
  // ------------------------------------------------------
  let foundValue = null;

  if (filters && Array.isArray(filters)) {
    // simple condition: [field, operation, value]
    if (typeof filters[0] === "string" && filters[0] === filterKey) return filters[2];

    for (let i = 0; i < filters.length; i++) {
      if (filters[i] && (filters[i] == filterKey || (Array.isArray(filters[i]) && filters[i][0] == filterKey))) {
        foundValue = filters[i][2]; // Get the value from the filter
        break;
      }
    }
  }

  return foundValue;
}
